import FullNumberTooltip from './full-number-tooltip';
import { columnResize } from './column-resize';
import { clipboard } from './clipboard';
import { elDraggableDialog } from './el-draggable-dialog';
import { permission } from './permission';
import { waves } from './waves';
import { excelPaste } from './excel-paste';

// Экспортируем все директивы для регистрации через Object.keys
export const fullNumberTooltip = FullNumberTooltip;
export const columnResizeDirective = columnResize;
export const clipboardDirective = clipboard;
export const elDraggableDialogDirective = elDraggableDialog;
export const permissionDirective = permission;
export const wavesDirective = waves;
export const excelPasteDirective = excelPaste;

// Также экспортируем для обратной совместимости
export * from './clipboard'
export * from './el-draggable-dialog'
export * from './permission'
export * from './waves'
export * from './excel-paste'
export * from './column-resize'

export default {
  install(Vue: any) {
    Vue.directive('full-number-tooltip', FullNumberTooltip);
    Vue.directive('column-resize', columnResize);
    Vue.directive('clipboard', clipboard);
    Vue.directive('el-draggable-dialog', elDraggableDialog);
    Vue.directive('permission', permission);
    Vue.directive('waves', waves);
    Vue.directive('excel-paste', excelPaste);
  }
}
